import React from 'react';
import { motion } from 'framer-motion';
import { dossierSections } from '../data/dossierSections';
interface CaseIndexProps {
  activeId: string;
}
export function CaseIndex({
  activeId
}: CaseIndexProps) {
  return <aside aria-label="Índice del expediente" className="fixed bottom-0 left-0 top-[52px] z-40 hidden w-[248px] overflow-hidden border-r border-gold/20 bg-[linear-gradient(180deg,#0e0e12,#0a0a0d)] px-5 py-6 lg:block" data-id="element-119" data-mp="xt6tbu5ztui9">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[repeating-linear-gradient(115deg,rgba(255,255,255,0.014)_0_2px,transparent_2px_26px)]" data-id="element-120" data-mp="1qeq7oklw7a1g" />

      <p className="relative font-mono text-[10px] tracking-[0.1em] text-gold-dim" data-id="element-121" data-mp="1hebc8sf7sek8">
        EXP. Nº VDB-2026-014
        <span className="ml-0.5 inline-block h-3 w-[6px] animate-caret bg-gold align-[-1px]" data-id="element-122" data-mp="1cje1nh2adx58" />
      </p>

      <motion.span initial={{
      opacity: 0,
      scale: 1.8,
      rotate: -14
    }} animate={{
      opacity: 1,
      scale: 1,
      rotate: -6
    }} transition={{
      duration: 0.6,
      delay: 0.4,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative mt-5 inline-flex rounded border-2 border-dashed border-signal-pink bg-signal-pink/[0.06] px-2.5 py-1.5 text-[11px] font-extrabold tracking-[0.12em] text-signal-pink [text-shadow:0_0_12px_rgba(255,47,146,0.5)]" data-id="element-123" data-mp="5ympa11ynfjf">
        CONFIDENCIAL
      </motion.span>

      <p className="relative mt-7 pl-0.5 text-[9.5px] uppercase tracking-[0.16em] text-ash" data-id="element-124" data-mp="16j95dfspaohj">
        Índice del Expediente
      </p>

      <nav className="relative mt-3" data-id="element-125" data-mp="wji7r58uftd8">
        <ul className="relative border-l border-white/10 pl-2.5" data-id="element-126" data-mp="wkjjlbxoojw0">
          {dossierSections.map(section => {
          const isActive = activeId === section.id;
          return <li key={section.id} className="relative" data-id="element-127" data-mp="mtynbv5hfrg9">
                <span aria-hidden="true" className={`absolute -left-[15px] top-1/2 h-1.5 w-1.5 -translate-y-1/2 rounded-full border transition-all duration-300 ${isActive ? 'border-gold bg-gold shadow-[0_0_8px_#d4af37]' : 'border-white/25 bg-white/15'}`} data-id="element-128" data-mp="8t4excifpqhl" />
                <a href={`#${section.id}`} aria-current={isActive ? 'true' : undefined} className={`flex items-baseline gap-2.5 rounded-r-md border-l-2 py-2 pl-2.5 pr-2 transition-colors duration-300 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gold ${isActive ? 'border-gold bg-gold/[0.09]' : 'border-transparent hover:bg-white/[0.03]'}`} data-id="element-129" data-mp="26pcu5rj62wd7">
                  <span className={`w-4 flex-shrink-0 font-mono text-[11px] ${isActive ? 'text-gold' : 'text-gold-dim'}`} data-id="element-130" data-mp="2khsq68dnhu4m">
                    {section.number}
                  </span>
                  <span className={`text-[11.5px] leading-tight ${isActive ? 'font-bold text-bone' : 'text-ash'}`} data-id="element-131" data-mp="yxxj6run8fdm">
                    {section.label}
                  </span>
                </a>
              </li>;
        })}
        </ul>
      </nav>

      <p className="absolute bottom-5 left-5 font-mono text-[8.5px] uppercase tracking-[0.14em] text-white/25" data-id="element-132" data-mp="1dnljpqv03a0a">
        Acceso Restringido · Nivel 5
      </p>
    </aside>;
}